// web-app/src/styles/theme.js
export const theme = {
  primaryBlue: "#2563eb", // vivid blue
  secondaryRed: "#ef4444", // vivid red
  accentGold: "#FFD700",   // gold
  backgroundGradient: "linear-gradient(135deg, #e0e7ff 0%, #f3f4f6 100%)", // soft blue to gray
  cardGradient: "linear-gradient(135deg, #2563eb 0%, #ef4444 100%)",
  white: "#fff",
  black: "#000",
  grayText: "#22292f", // dark gray for text
  grayLight: "#e5e7eb", // light gray for backgrounds/dividers/hover
  textPrimary: "#1e293b",
  textSecondary: "#64748b",
//   borderRadius: "18px",
  boxShadow: "0 4px 24px 0 rgba(37,99,235,0.08)",
  fontFamily: "'Inter', 'Segoe UI', 'Arial', 'Helvetica', sans-serif" // modern, highly readable font
};